import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-reference-value-sheet-router',
  templateUrl: './reference-value-sheet-router.component.html',
  imports: [RouterOutlet],
})
export class ReferenceValueSheetRouterComponent {
  constructor() {}
}
